const dataOrderBook = [
  {
    valuationRange: 925000000,
    amount: 212500000,
    orderCount: 10,
    date: '08/03/20'
  },
  {
    valuationRange: 975000000,
    amount: 156000000,
    orderCount: 7,
    date: '08/03/20'
  },
  {
    valuationRange: 1025000000,
    amount: 135000000,
    orderCount: 5,
    date: '08/03/20'
  }
];

export default dataOrderBook;
